import './Main.css';
import Header from '../../Components/Header/Header';
import { Link } from 'react-router-dom';
import CartMain from '../../Components/Cart/CartMain/CartMain';
import CheckoutMain from '../../Components/CheckoutMain/CheckoutMain';
import DoneMain from '../../Components/DoneMain/DoneMain';
import Footer from '../../Components/Footer/Footer';


const Main = () => {
    return ( 
            <div className="main">
                <div className="head">
                    <Header />
                </div>

                <div className="main-two">
                <nav>
                        <Link to="#cart" onClick={event =>  window.location.href='#cart'}><button><h5>01. CART</h5></button></Link>
                        <Link to="#checkout" onClick={event =>  window.location.href='#checkout'}><button><h5>02. CHECKOUT</h5></button></Link>
                        <Link to="#done" onClick={event =>  window.location.href='#done'}><button><h5>03. DONE</h5></button></Link>
                    </nav>

                <div className="main-content">
                   
                    <div className="main-body">
                        <div className="cart" id="cart">
                            <CartMain />
                        </div>
                        <div className="checkout" id="checkout">
                            <CheckoutMain />
                        </div>
                        <div className="done" id="done">
                            <DoneMain />
                        </div>
                    </div>
                </div>
                </div>

                
                <footer className="app-footer">
                    <Footer />
                </footer>
            </div>
            
     );
}
 
export default Main;